import { render } from "./LeftPanel.vue?vue&type=template&id=31939f0c&ts=true"
import script from "./LeftPanel.vue?vue&type=script&lang=ts"
export * from "./LeftPanel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__